// @flow
'use strict'

const flow_ = require('lodash/flow')
const curry_ = require('lodash/curry')
const mapValues_ = require('lodash/mapValues')

const { assign, bind } = require('./utils')
const { freshCollection, fromWarmupCollection } = require('./collections')

/*::
import type { Collection, Store } from './types'
*/

const freshStore /*: (mainCollectionName: string) => Store */ = mainCollectionName =>
  Object.assign(
    {},
    {
      [mainCollectionName]: Object.assign({}, freshCollection())
    }
  )

const fromWarmupStore /*: Store => Store */ = warmupStore => {
  return mapValues_(warmupStore, fromWarmupCollection)
}

const setCollection = curry_((
  name /*: string */,
  collection /*: Collection */
) /*: (Store => Store) */ => assign({ [name]: collection }))

const getCollection = (collectionName /*: string */) => (store /*: Store */) =>
  store[collectionName]

const updateCollection = (
  collectionName /*: string */,
  updateFn /*: (Collection => Collection) */
) /*: (Store => Store) */ =>
  bind(
    flow_(getCollection(collectionName), updateFn),
    setCollection(collectionName)
  )

module.exports.freshStore = freshStore
module.exports.fromWarmupStore = fromWarmupStore
module.exports.getCollection = getCollection
module.exports.setCollection = setCollection
module.exports.updateCollection = curry_(updateCollection)



// WEBPACK FOOTER //
// ./record-store/store.js